import React, { useState } from 'react';

interface GreatForTagsProps {
  tags: string[];
  showLabel?: boolean;
}

const GreatForTags: React.FC<GreatForTagsProps> = ({
  tags,
  showLabel = true,
}) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const MAX_VISIBLE = 5;

  // Ensure all tags are strings - filter out any non-string values
  const validTags = tags.filter(
    (tag): tag is string => typeof tag === 'string' && tag.trim().length > 0
  );

  const showButton = validTags.length > MAX_VISIBLE;
  const displayedTags = isExpanded
    ? validTags
    : validTags.slice(0, MAX_VISIBLE);
  const extraCount = validTags.length - MAX_VISIBLE;

  if (validTags.length === 0) {
    return null;
  }

  return (
    <div className='mb-8'>
      <div className='flex flex-wrap items-center gap-3 text-sm text-black/80 pt-2'>
        {showLabel && <span className='font-bold text-black'>Great for:</span>}
        {displayedTags.map((tag, idx) => (
          <span
            key={idx}
            className='border border-lightgrey rounded-lg px-2.5 py-2 leading-none md:text-sm text-xs text-darkgrey'
          >
            {String(tag)}
          </span>
        ))}
        {showButton && (
          <button
            onClick={() => setIsExpanded(!isExpanded)}
            className='flex items-center gap-1 text-xs text-black no-underline transition-all'
          >
            <span>{isExpanded ? 'Show less' : `+${extraCount} more`}</span>
          </button>
        )}
      </div>
    </div>
  );
};

export default GreatForTags;
